import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { applyDocumentMeta } from './seoMeta';

const container = document.getElementById('root');

/**
 * Deliberately createRoot, not hydrateRoot, even though the public routes
 * arrive prerendered.
 *
 * <p>Hydration was tried first and fails on every route with React error #418,
 * "the server rendered text didn't match the client" — and it fails for a
 * reason that cannot be fixed from this side. Real server rendering emits
 * `<!-- -->` separators between adjacent text nodes, so that a fragment like
 * `Last updated: {date} · {n} sections` hydrates back into the same three text
 * nodes React created. scripts/prerender.js is not a server renderer: it
 * snapshots a live DOM with outerHTML, and serialization merges adjacent text
 * nodes into one. React then expects three and finds one.
 *
 * <p>The final DOM is provably identical either way — a byte-for-byte diff of
 * the prerendered markup against the client-rendered markup matches exactly —
 * so hydrating bought nothing here except a recoverable error on every page
 * load and a subtree regeneration anyway. Mounting fresh is the same outcome,
 * predictably and silently.
 *
 * <p>None of this weakens the prerender, because the prerender is not for the
 * browser. It is for the crawlers that never run this file at all: Googlebot
 * gets its content without waiting on JS, and GPTBot, ClaudeBot, PerplexityBot
 * and CCBot — which do not execute JavaScript — get a real page instead of an
 * empty div. Fixing this properly means server rendering, i.e. Next.js.
 */
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The prerendered file already carries the correct title for its own route;
// this keeps it correct across client-side navigation afterwards.
applyDocumentMeta(window.location.pathname);
